import axios, { AxiosResponse } from "axios";
import { setAxiosHeader } from "shared/utils/axiosUtils";
import { ISsoTokenParams, ISSOToken } from "dataModels/ooauth2";
import {GET_USER_DATA} from "shared/constants";
import { appStore } from "state/appStore";
import { AppUser } from "ooAuth2/appUser";
const ENV_SOURCE = window&&window._env_?window._env_:process.env;
const MODULE: string = "/b2b";
const appUser: AppUser = new AppUser();

export const getSSOToken = (payload:ISsoTokenParams):Promise<AxiosResponse<ISSOToken>>=>{
    //On refresh token, it needs to delete all custom headers or it won't work
    let plantIdValue: string|undefined = appStore.getState().plant.plantId;
    //console.log(payload.grant_type)
    //console.log(axios.defaults.headers)
    //console.log("plantId" in axios.defaults.headers.common)
    if(payload.grant_type === "refresh_token" && ("plantId" in axios.defaults.headers.common)){
        //console.log('refresh');
        plantIdValue = appStore.getState().plant.plantId as string;
        delete axios.defaults.headers.common['plantId']; //perchè?
    }
    return axios.post(ENV_SOURCE.REACT_APP_SSO_TOKEN_URL!, payload,{headers: {"Content-Type": "application/x-www-form-urlencoded"}})
    .finally(()=>{
        if(plantIdValue!==undefined){
            setAxiosHeader('plantId', plantIdValue);
        }
    });
}

/* Get user data by sso token */
export const getUserData = (ssoToken:string)=>{
    return axios.get(ENV_SOURCE.REACT_APP_HOST_USER_DATA + MODULE + GET_USER_DATA)
}